import {
  oktaConfig,
  issuer,
  resolveAccountOidcOptions,
  getOauthBrowsingContextOrigin,
  assignOauthRedirectLocation,
} from './okta-config';

function getLocationSearchSuffix() {
  if (typeof window === 'undefined' || window.location?.search == null) {
    return '';
  }
  return String(window.location.search).replace('?', '&');
}

function buildOktaWidgetDefaultConfiguration() {
  const { clientId, redirectPath } = resolveAccountOidcOptions();
  return {
    baseUrl: oktaConfig.baseUrl,
    clientId,
    redirectUri: `${getOauthBrowsingContextOrigin()}${redirectPath}`,
    useClassicEngine: true,
    authParams: {
      issuer,
      pkce: true,
      display: `page`,
      responseType: 'code',
      setLocation: assignOauthRedirectLocation,
    },
  };
}

export const oktaWidgetID = '#okta-widget-container';

/** @deprecated Prefer buildOktaWidgetConfiguration() so EHR vs default OIDC client resolves at call time. */
export const oktaWidgetConfiguration = (() => {
  const base = buildOktaWidgetDefaultConfiguration();
  return {
    ...base,
    el: oktaWidgetID,
    i18n: {
      en: {
        'errors.E0000004': `The password or email you entered did not match our records. Please double-check and try again. For help logging in, click “Trouble logging in?” below.`,
        'primaryauth.username.tooltip': ' ',
        'primaryauth.title': 'Welcome to Tempus',
        'primaryauth.submit': 'Log in',
        'primaryauth.username.placeholder': 'Email',
        'error.username.required': 'Please input your email',
        'error.password.required': 'Please input your password',
        'error.auth.lockedOut': 'Your account is locked. Please contact your administrator.',
        'password.forgot.email.or.username.placeholder': 'Email',
        'password.forgot.email.or.username.tooltip': ' ',
        'oform.errorbanner.title': 'Please fill out all fields',
        // Okta widget doesn't directly support hiding this link
        // But if the string is blank (not empty), the link won't be rendered :shrug:
        forgotpassword: ' ',
        goback: 'Return to sign in',
      },
    },
    features: {
      router: true,
      rememberMe: true,
      showPasswordToggleOnSignInPage: true,
      selfServiceUnlock: false,
      registration: false,
      webauthn: false,
      // Used to enable the idp discovery feature on the widget.
      // REQUIRED for third-party SSO support
      idpDiscovery: true,
    },
    idpDiscovery: {
      requestContext: `${getOauthBrowsingContextOrigin()}?fromLogin=true${getLocationSearchSuffix()}`,
    },
  };
})();

/** Full widget config with current OIDC client (default Account UI vs EHR). */
export function buildOktaWidgetConfiguration() {
  return {
    ...buildOktaWidgetDefaultConfiguration(),
    el: oktaWidgetID,
    i18n: { ...oktaWidgetConfiguration.i18n },
    features: { ...oktaWidgetConfiguration.features },
    idpDiscovery: {
      requestContext: `${getOauthBrowsingContextOrigin()}?fromLogin=true${getLocationSearchSuffix()}`,
    },
  };
}
